module.exports = __webpack_public_path__ + "static/Homepage-Hero4-9d82895ef9e29d4641ab73dd12109820.png";